import * as React from 'react';
const SvgJson = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="#697077"
      d="M14 22v-6.5h8v2.339c0 .527 0 .982-.03 1.356-.033.395-.104.789-.297 1.167a3 3 0 0 1-1.311 1.311c-.378.193-.772.264-1.167.296-.375.031-.83.031-1.357.031zM14 22v-6.5H6v2.339c0 .527 0 .982.03 1.356.033.395.104.789.297 1.167a3 3 0 0 0 1.311 1.311c.378.193.772.264 1.167.296.375.031.83.031 1.357.031z"
    />
    <path fill="#8B919A" d="M14 8.5h8v7h-8z" />
    <path fill="#697077" d="M6 8.5h8v7H6z" />
    <path
      fill="#A2A9B0"
      d="M14 2v6.5h8V6.161c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296A18 18 0 0 0 17.838 2z"
    />
    <path
      fill="#8B919A"
      d="M14 2v6.5H6V6.161c0-.527 0-.981.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296C9.18 2 9.635 2 10.162 2z"
    />
    <path
      fill="currentColor"
      d="M4.6 7c-.329 0-.613 0-.847.02a1.9 1.9 0 0 0-.73.184c-.352.18-.639.467-.819.82a1.9 1.9 0 0 0-.185.73C2 8.986 2 9.27 2 9.6v4.798c0 .33 0 .614.02.848.02.247.064.493.184.73.18.352.467.639.82.819.236.12.482.165.73.185.233.019.517.019.847.019h4.798c.33 0 .614 0 .848-.02a1.9 1.9 0 0 0 .73-.184c.352-.18.639-.467.819-.82a1.9 1.9 0 0 0 .185-.73C12 15.014 12 14.73 12 14.4V9.601c0-.33 0-.614-.02-.848a1.9 1.9 0 0 0-.184-.73 1.88 1.88 0 0 0-.82-.819 1.9 1.9 0 0 0-.73-.185C10.014 7 9.73 7 9.4 7z"
    />
    <path
      fill="#fff"
      d="M3.672 10.637a.3.3 0 0 1-.305-.297.3.3 0 0 1 .305-.297.3.3 0 0 1 .305.297.3.3 0 0 1-.305.297m-.465 3.053c-.053 0-.121-.002-.156-.006v-.43l.072.004c.19 0 .264-.06.264-.23v-2.122h.57v2.137c0 .426-.26.647-.75.647m1.992-.647c-.58 0-.902-.268-.947-.664l-.002-.018h.557l.004.018c.037.164.16.26.388.26.215 0 .346-.084.346-.22v-.001c0-.111-.07-.176-.275-.22l-.356-.075c-.406-.086-.611-.289-.611-.601v-.002c0-.399.343-.657.877-.657.556 0 .867.295.88.662v.02h-.525l-.002-.016c-.02-.15-.142-.263-.353-.263-.198 0-.32.088-.32.222v.002c0 .108.072.178.283.223l.355.076c.438.092.617.264.617.572v.002c0 .41-.377.68-.916.68m2.158 0c-.636 0-1.037-.408-1.037-1.09v-.004c0-.674.41-1.086 1.035-1.086.627 0 1.04.409 1.04 1.086v.004c0 .684-.405 1.09-1.038 1.09m.002-.447c.278 0 .455-.235.455-.643v-.004c0-.404-.181-.639-.459-.639-.275 0-.455.235-.455.64v.003c0 .41.178.643.46.643M8.69 13v-2.094h.57v.344h.012c.108-.24.323-.387.64-.387.46 0 .722.295.722.785V13h-.57v-1.234c0-.274-.13-.43-.385-.43-.256 0-.418.187-.418.46V13z"
    />
  </svg>
);
export default SvgJson;
